export const statuses = {
  RUN: 'RUN',
  PAUSE: 'PAUSE',
};

export const generationEvents = {
  BIRTH: 'BIRTH',
  DEATH: 'DEATH',
  MANUAL_BIRTH: 'MANUAL_BIRTH',
  MANUAL_DEATH: 'MANUAL_DEATH',
};



// WEBPACK FOOTER //
// ./src/store/types.js